import { Col, Row } from "antd/es/grid";
import { CloseModal } from "../../../hooks/useModal";
import BaseDialog from "../../../components/BaseDialog";
import DialogFooter from "../../../components/DialogFooter";
import { useMemo, useRef, useState } from "react";
import {
  OrderItemMappingRequest,
  OrderResponse,
} from "../../../../infrastructure/model/OrderModel";
import usePageState from "../../../hooks/usePageState";
import useAsyncEffect from "../../../hooks/useAsyncEffect";
import dayjs from "dayjs";
import { useItemsContext } from "../../../context/AppItemsContext";
import { useToppingContext } from "../../../context/AppToppingContext";
import { useReactToPrint } from "react-to-print";
import { ITEM_TYPE_ENUM, SIZE_MAPPING_OPTION } from "../../../../applications/constants/AppConst";
import "../styles/KitchenBillDialog.scss";
import { getItemInOrderUseCase } from "../../../../applications/useCase/ApiUseCase/OrderApiUseCase";

interface KitchenBillDialogProps {
  onClose: CloseModal;
  orderItem: OrderResponse;
}

function KitchenBillDialog(props: KitchenBillDialogProps) {
  const { onClose, orderItem } = props;
  const { items } = useItemsContext();
  const { toppings } = useToppingContext();

  const [itemMappings, setItemMappings] = useState<OrderItemMappingRequest[]>([]);
  const { setLoading, isLoading, showError } = usePageState();

  const printRef = useRef<HTMLDivElement>(null);

  const reactToPrintFn = useReactToPrint({
    contentRef: printRef,
    onAfterPrint: () => {
      onClose(false);
    },
    onPrintError: (errorLocation, error) => {
      showError(error.message);
    },
  });

  async function getItemsInOrder(orderId: number) {
    const res = await getItemInOrderUseCase({
      orderId,
      setLoading,
      showError,
    });
    if (res) {
      setItemMappings(res);
    }
  }

  useAsyncEffect(async () => {
    await getItemsInOrder(orderItem.id);
  }, []);

  const totalQuantity = useMemo(() => {
    return itemMappings.reduce((sum, item) => {
      const currentItem = items.find((t) => t.id === item.item_id);
      if (currentItem?.type === ITEM_TYPE_ENUM.OTHER) {
        return sum;
      } else {
        return sum + item.item_quantity;
      }
    }, 0);
  }, [itemMappings]);

  let cupIndex = 0; // counter toàn cục

  return (
    <BaseDialog
      title="Phiếu Gọi Món"
      loading={isLoading}
      width={"20vw"}
      footer={
        <DialogFooter
          submitProps={{
            onClick: reactToPrintFn,
            children: "In Phiếu",
          }}
          cancelProps={{
            onClick: () => onClose(false),
          }}
        />
      }
      className="p-0"
    >
      <Col
        ref={printRef}
        span={24}
        className="pl-3 pr-3"
        style={{
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Row className="w-100 justify-content-center mt-2 no-print">Mã HĐ: {orderItem.code}</Row>
        <Row className="w-100 justify-content-center mt-2 no-print">
          {dayjs().format("DD/MM/YYYY HH:mm")}
        </Row>

        <Row className="mt-2 flex-1 kitchen-bill-item-list-container" style={{ gap: 0 }}>
          {itemMappings?.map((row: OrderItemMappingRequest, index) => {
            const currentItem = items.find((e) => e.id === row.item_id);
            if (!currentItem || currentItem.type === ITEM_TYPE_ENUM.OTHER) return <></>;
            const itemNote = row.item_note;

            const arrTemp = Array.from({ length: row.item_quantity }, (_, i) => i);
            return arrTemp?.map((arrTemp, tempIndex) => {
              cupIndex++;
              return (
                <Col
                  span={24}
                  key={tempIndex}
                  className="page-break"
                  style={{
                    borderRadius: 0,
                    display: "flex",
                    fontSize: "10px",
                    paddingTop: "8px",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    backgroundColor: "#fff",
                  }}
                >
                  <Row className="w-100 justify-content-center " style={{ fontSize: 10 }}>
                    Toputii cảm ơn
                  </Row>
                  <div style={{ fontWeight: "bold", fontSize: 10, marginBottom: 8 }}>
                    {currentItem.name} (
                    {SIZE_MAPPING_OPTION?.find((s) => s.value === row.item_size)?.label}) (
                    {cupIndex}/{totalQuantity}) &nbsp;&nbsp;
                    {(
                      currentItem.size_mapping?.find((c) => c.size === row.item_size)?.price || 0
                    )?.toLocaleString()}
                  </div>

                  {itemNote && (
                    <div style={{ fontSize: 10, marginBottom: 4 }}>
                      <strong>Ghi chú:</strong>{" "}
                      <span style={{ whiteSpace: "pre-wrap" }}>{itemNote}</span>
                    </div>
                  )}
                  {row?.topping_ids?.length! > 0 &&
                    row?.topping_ids?.map((rm, rmIndex) => (
                      <div
                        style={{
                          fontSize: 10,
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                        key={rmIndex}
                      >
                        <span style={{ whiteSpace: "pre-wrap" }}>
                          {toppings.find((t) => t.id === rm)?.name}
                        </span>
                        <span style={{ whiteSpace: "pre-wrap" }}>
                          {toppings.find((t) => t.id === rm)?.price?.toLocaleString()}
                        </span>
                      </div>
                    ))}
                  <Row className="w-100 justify-content-center " style={{ fontSize: 10 }}>
                    {dayjs().format("DD/MM/YYYY HH:mm")}
                  </Row>
                </Col>
              );
            });
          })}
        </Row>
      </Col>
    </BaseDialog>
  );
}
export default KitchenBillDialog;
